<template>
  <div class="background" :class="`background-step-${currentStep}`">
    <div class="background-assets coat1-mobile is-hidden-tablet"></div>
    <div class="background-assets coat1 is-hidden-mobile"></div>
    <div class="background-assets coat2 is-hidden-mobile"></div>
  </div>
</template>

<script>
  export default {
    name: 'LCBackground',
    props: {
      currentStep: {
        type: Number,
        default: undefined
      }
    }
  }
</script>

<style lang="scss" scoped>
.background {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 0;

  background: rgb(62,41,195);
  // background: radial-gradient(circle, rgba(62,41,195,1) 36%, rgba(146,105,214,1) 100%);

  background: linear-gradient(270.47deg, #3926A6 0%, #7351CF 100%);
  background-size: calc(6*100vw) 100%;

  transition: all .25s ease;
}

.background-assets {
  position: absolute;
  width: 100%;
  height: 100%;
  transition: all .5s ease;
  opacity: 0;
}

.coat1-mobile {
  background: url('~@/assets/leadcatcher-assets/coat-mobile.png') no-repeat;
  background-position: calc(80vw - (279px / 2)) 32px;
}

.coat1 {
  background: url('~@/assets/leadcatcher-assets/coat1.png') no-repeat;
  background-position: calc(100vw - (1092px / 2)) calc(100% + 400px);
}

.coat2 {
  background: url('~@/assets/leadcatcher-assets/coat2-w-other-coat.png') no-repeat;
  background-position: calc(200%) calc(100% + 200px);
}

.background-step-1 {
  background-position:0 0;

  .coat1 { opacity: 1; }
  .coat1-mobile { opacity: 1; }
}
.background-step-2 {
  background-position:calc(-1*100vw) 0;

  .coat1-mobile { opacity: 0; background-position: -200% 32px }
  .coat1 { opacity: 1; background-position: calc(-1092px / 2) calc(100% + 400px) }
  .coat2 { opacity: 0.1; background-position: calc(100vw - (852px / 2 - 100px)) calc(100% + 200px) }
}
.background-step-3 {
  background-position:calc(-2*100vw) 0;

  .coat1 { opacity: 0; background-position: -200% calc(100% + 400px) }
  .coat2 { opacity: 1; background-position: calc(-852px / 2 + 100px) calc(100% + 200px) }
}
.background-step-4 {
  background-position:calc(-3*100vw) 0;
}
.background-step-5 {
  background-position:calc(-4*100vw) 0;
}
.background-step-6,
.background-step-7,
.background-step-8 {
  background-position:calc(-5*100vw) 0;
}

.background-step-4,
.background-step-5,
.background-step-6,
.background-step-7,
.background-step-8 {
  .coat1 { opacity: 0; background-position: -200% calc(100% + 400px) }
  .coat2 { opacity: 0; background-position: -200% calc(100% + 200px) }
}
</style>
